const dragDialog = {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    
    if (!dialogHeaderEl || !dragDom) return
    
    // 设置鼠标样式
    dialogHeaderEl.style.cursor = 'move'
    dialogHeaderEl.style.userSelect = 'none'
    
    // 添加平滑过渡效果
    dragDom.style.transition = 'none'

    dialogHeaderEl.onmousedown = (e) => {
      // 阻止默认事件，避免选中文字
      e.preventDefault()
      
      // 获取当前dialog的位置信息
      const dragDomRect = dragDom.getBoundingClientRect()
      
      // 记录鼠标按下时的坐标和dialog的初始位置
      const disX = e.clientX - dragDomRect.left
      const disY = e.clientY - dragDomRect.top
      
      // 获取可视区域的宽高
      const screenWidth = document.documentElement.clientWidth || document.body.clientWidth
      const screenHeight = document.documentElement.clientHeight || document.body.clientHeight
      
      // 获取dialog的宽高
      const dialogWidth = dragDom.offsetWidth
      const dialogHeight = dragDom.offsetHeight
      
      // 计算dialog可移动的最小和最大位置
      const minLeft = 0
      const maxLeft = screenWidth - dialogWidth
      const minTop = 0
      const maxTop = screenHeight - dialogHeight

      document.onmousemove = function (e) {
        // 计算移动后的位置
        let left = e.clientX - disX
        let top = e.clientY - disY
        
        // 边界限制，确保dialog不会超出屏幕
        if (left < minLeft) {
          left = minLeft
        } else if (left > maxLeft) {
          left = maxLeft
        }
        
        if (top < minTop) {
          top = minTop
        } else if (top > maxTop) {
          top = maxTop
        }
        
        // 设置dialog的位置
        dragDom.style.left = `${left}px`
        dragDom.style.top = `${top}px`
        dragDom.style.marginTop = '0'
        dragDom.style.marginLeft = '0'
      }

      document.onmouseup = function (e) {
        // 鼠标弹起，移除事件监听
        document.onmousemove = null
        document.onmouseup = null
      }
      
      // 返回false阻止默认行为
      return false
    }
  }
}
export default dragDialog